import React from "react";
import withTranslate, { WithTranslateProps } from "../common/WithTranslate";
import { inject, observer } from "mobx-react";
import styled from "@emotion/styled";
import DateInput from "../common/input/DateInput";
import { Button, Intent, Tooltip, Label, Checkbox, Spinner, Tabs, Tab } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { TLCode } from "../../common/enums";
import moment from "moment";
import { TranslatedMessage } from "../common/translation";
import { Instance } from "mobx-state-tree";
import { DutyAssignmentStore } from "../../store";
import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, FilterPanel, FilterRow, HeaderFilter, Pager, Paging, SearchPanel } from "devextreme-react/cjs/data-grid";

interface MediaSanteApiCheckProps extends WithTranslateProps {
  DutyAssignmentStore?: Instance<typeof DutyAssignmentStore>;
}

interface MediaSanteApiCheckState {
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
  oneDay: boolean;
  dataResponse?: any[];
  isLoading: boolean;
  currentTab?: MediaSanteTab;
}

enum MediaSanteTab {
  Main = 'main',
  JsonView = 'jsonView',
  TableView = 'tableView'
}

@inject('DutyAssignmentStore')
@observer
class MediaSanteApiCheck extends React.Component<MediaSanteApiCheckProps, MediaSanteApiCheckState> {
  state: MediaSanteApiCheckState = {
    dateFrom: undefined,
    dateTo: undefined,
    oneDay: false,
    dataResponse: undefined,
    isLoading: false,
    currentTab: undefined
  };

  _isMounted = false;

  componentDidMount = async () => {
    this._isMounted = true;
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  dateFromSearchChange(value: Date) {
    this.setState({ dateFrom: value });
  }

  dateToSearchChange(value: Date) {
    this.setState({ dateTo: value });
  }

  sendForm = async () => {
    if (this.props.DutyAssignmentStore && this.state.dateFrom && this.state.dateTo) {
      this.setState({ isLoading: true, dataResponse: undefined });
      await this.props.DutyAssignmentStore.getMadiasanteResponse(
        moment(this.state.dateFrom).format('DD-MM-YYYY'),
        moment(this.state.dateTo).format('DD-MM-YYYY')
      ).then((response) => this.setState({
        //dataResponse: response as any[],
        isLoading: false
      }));
    }
  }

  changeTab = async (tabId: MediaSanteTab) => {
    this._isMounted && this.setState({ currentTab: tabId });
  };

  render() {
    const { translate } = this.props;
    const { dateFrom, dateTo, dataResponse } = this.state;

    return (
      <Container>
        <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'flex-start', marginBottom: '20px' }}>
          <DivColumn>
            <DivLine>
              <Label style={{ margin: 0, marginRight: '10px' }}>{translate(TLCode.StartDate)}</Label>
              <Tooltip content={translate(TLCode.GENERAL_PreviousDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_LEFT}
                  small={true}
                  style={{ height: '30px', marginRight: '5px' }}
                  onClick={() => {
                    const date = moment(dateFrom)
                      .startOf('day')
                      .subtract(1, 'd')
                      .set('hours', 2);
                    this.dateFromSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateToSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <DateInput
                value={dateFrom}
                canClearSelection={false}
                onChange={(value) => {
                  this.dateFromSearchChange(value);
                  if (this.state.oneDay) {
                    this.dateToSearchChange(value);
                  }
                }}
              />
              <Tooltip content={translate(TLCode.GENERAL_NextDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_RIGHT}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    const date = moment(dateFrom)
                      .startOf('day')
                      .add(1, 'd')
                      .set('hours', 2);
                    this.dateFromSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateToSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <Tooltip content={translate(TLCode.GENERAL_Today)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.DOUBLE_CHEVRON_DOWN}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    const date = moment(new Date())
                      .startOf('day')
                      .set('hours', 2);
                    this.dateFromSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateToSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
            </DivLine>
          </DivColumn>
          <DivColumn>
            <DivLine>
              <Checkbox
                style={{ margin: 0 }}
                name="OneDay"
                checked={this.state.oneDay}
                onChange={(event) => this.setState({ oneDay: event.currentTarget.checked })}
              >
                <TranslatedMessage id={TLCode.MESSAGE_OneDay} />
              </Checkbox>
            </DivLine>
          </DivColumn>
          <DivColumn>
            <DivLine>
              <Label style={{ margin: 0, marginRight: '10px' }}>{translate(TLCode.EndDate)}</Label>
              <Tooltip content={translate(TLCode.GENERAL_PreviousDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_LEFT}
                  small={true}
                  style={{ height: '30px', marginRight: '5px' }}
                  onClick={() => {
                    const date = moment(this.state.dateTo)
                      .endOf('day')
                      .subtract(1, 'd')
                      .set('hours', 2);
                    this.dateToSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateFromSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <DateInput
                value={dateTo}
                canClearSelection={false}
                onChange={(value) => {
                  this.dateToSearchChange(value);
                  if (this.state.oneDay) {
                    this.dateFromSearchChange(value);
                  }
                }}
              />
              <Tooltip content={translate(TLCode.GENERAL_NextDay)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.CHEVRON_RIGHT}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    const date = moment(this.state.dateTo)
                      .endOf('day')
                      .add(1, 'd')
                      .set('hours', 2);
                    this.dateToSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateFromSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
              <Tooltip content={translate(TLCode.GENERAL_Today)} hoverOpenDelay={700}>
                <Button
                  icon={IconNames.DOUBLE_CHEVRON_DOWN}
                  small={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => {
                    const date = moment(new Date())
                      .startOf('day')
                      .set('hours', 2);
                    this.dateToSearchChange(date.toDate());
                    if (this.state.oneDay) {
                      this.dateFromSearchChange(date.toDate());
                    }
                  }}
                />
              </Tooltip>
            </DivLine>
          </DivColumn>
          <DivColumn>
            <Button
              text={translate(TLCode.GENERAL_Send)}
              intent={Intent.PRIMARY}
              onClick={async () => await this.sendForm()}
              disabled={this.state.isLoading}
            />
          </DivColumn>
        </div>
        <Tabs
          id={MediaSanteTab.Main}
          defaultSelectedTabId={MediaSanteTab.JsonView}
          onChange={this.changeTab}
          renderActiveTabPanelOnly={true}
        >
          {/* Json view tab */}
          <Tab id={MediaSanteTab.JsonView}
            title={translate(TLCode.MEDIASANTE_TAB_Json)}
            panel={
              <div style={{
                border: 'solid, 1px, #ccc',
                marginTop: '0px',
                width: '100%',
                height: '50vh',
                overflowY: 'auto',
                position: 'relative'
              }}>
                {this.state.isLoading && (
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1
                  }}>
                    <Spinner />
                  </div>
                )}
                {dataResponse && (
                  <span style={{
                    position: 'absolute',
                    top: '10px',
                    right: '25px',
                    zIndex: 1,
                    color: '#ff3b3bff'
                  }}>
                    {translate(TLCode.MEDIASANTE_nbRecords, { nbRecords: dataResponse.length })}
                  </span>
                )}
                {dataResponse && (
                  <pre style={{ textAlign: "left", background: "#f4f4f4b4", borderRadius: "8px", height: '100%', margin: 0 }}>
                    {/* {jsonResponse} */}
                    {JSON.stringify(dataResponse, null, 2)}
                  </pre>
                )}
              </div>
            }
          />

          {/* Table view tab */}
          <Tab id={MediaSanteTab.TableView}
            title={translate(TLCode.MEDIASANTE_TAB_Table)}
            panel={
              <div style={{
                border: 'solid, 1px, #ccc',
                marginTop: '0px',
                width: '100%',
                height: '50vh',
                overflowY: 'auto',
                position: 'relative',
                padding: '10px'
              }}>
                {this.state.isLoading && (
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1
                  }}>
                    <Spinner />
                  </div>
                )}

                {dataResponse && (
                  <span style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    zIndex: 1,
                    color: '#ff3b3bff'
                  }}>
                    {translate(TLCode.MEDIASANTE_nbRecords, { nbRecords: dataResponse.length })}
                  </span>
                )}

                {dataResponse && (<DataGrid
                  dataSource={dataResponse}
                  allowColumnReordering={true}
                  rowAlternationEnabled={true}
                  showBorders={true}
                  width="100%"
                  allowColumnResizing={true}
                  columnResizingMode={'widget'}
                >
                  <FilterRow visible={true} applyFilter={'auto'} />
                  <FilterPanel visible={true} />
                  <HeaderFilter visible={true} />
                  <SearchPanel visible={true} highlightCaseSensitive={true} width={300} />
                  <ColumnChooser enabled={true} />

                  <Column
                    dataField="date"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_Date)}
                    minWidth={120}
                    width={120}
                    dataType="date"
                    format="EEE. dd/MM/yyyy"
                  />
                  <Column
                    dataField="type"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_Type)}
                    minWidth={70}
                    width={70}
                  />
                  <Column
                    dataField="apbnumber"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_ApbNumber)}
                    minWidth={100}
                    width={100}
                  />
                  <Column
                    dataField="name"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_Name)}
                    minWidth={120}
                  />
                  <Column
                    dataField="address"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_Address)}
                    minWidth={120}
                  />

                  <Column
                    dataField="zipCode"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_ZipCode)}
                    minWidth={90}
                    width={100}
                  />

                  <Column
                    dataField="city"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_City)}
                    minWidth={100}
                    width={150}
                  />

                  <Column
                    dataField="phone"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_Phone)}
                    minWidth={100}
                    width={100}
                  />

                  <Column
                    dataField="secretariat"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_Secretariat)}
                    minWidth={90}
                    width={90}
                  />
                  <Column
                    dataField="group"
                    caption={this.props.translate(TLCode.MEDIASANTE_TABLE_Group)}
                    minWidth={100}
                    width={120}
                  />
                  <Pager
                    visible={true}
                    allowedPageSizes={[5, 10, 20, 50, 100]}
                    showPageSizeSelector={true}
                    showInfo={true}
                    showNavigationButtons={true}
                  />
                  <Paging defaultPageSize={20} />
                </DataGrid>
                )}
              </div>
            }
          />
        </Tabs>
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const DivColumn = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 20px;
`;

export default withTranslate(MediaSanteApiCheck);